/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author       Afternet <info@afternet.gr>
 *  @copyright Afternet
 *  @license      http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */


export default class servicesBoxSlider{
    init (){
        if($('.js-servicesBox-slider').length){

            var swiper = new Swiper(".js-servicesBox-slider", {
                slidesPerView: "auto",
                freeMode: true,
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                spaceBetween: 24,
                navigation: {
                    nextEl: '.js-gtServices-slider-next',
                    prevEl: '.js-gtServices-slider-prev'
                }
            });
        }
    }
}
